import request from '@/utils/request'

export function getEvlAdjDetail(param) {
    let data = param        
    return request({
      url: `/v10/getEvlAdjDetail`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  export function chkGmgr(param) {
    let data = param
    return request({
      url: `/v10/chkGmgr`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }
   
  export function insertAdjEvl(param) {
    let data = param
    return request({
      url: `/v10/insertAdjEvl`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }
